import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function FinalCTASection() {
  const {
    minutes,
    seconds,
    isUrgent
  } = useCountdown(15);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  return <section className="py-24 px-4 bg-brand-dark text-white text-center" data-id="element-82">
      <div className="max-w-4xl mx-auto" data-id="element-83">
        <h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight text-brand-primary" data-id="element-84">
          El oficio que aprendés hoy es la libertad que tenés mañana.
        </h2>

        <div className="bg-slate-800 p-8 md:p-12 rounded-3xl border border-slate-700 mb-12 max-w-2xl mx-auto shadow-2xl" data-id="element-85">
          <p className="text-xl font-bold text-gray-300 mb-6" data-id="element-86">
            ⏰ Precio de $19.990 disponible solo por tiempo limitado.
          </p>
          <div className={`flex justify-center gap-4 mb-8 ${isUrgent ? 'animate-blink' : ''}`} data-id="element-87">
            <div className={`text-6xl md:text-7xl font-black ${isUrgent ? 'text-red-500' : 'text-white'}`} data-id="element-88">
              {formatTime(minutes)}
            </div>
            <div className="text-6xl md:text-7xl font-black text-gray-500" data-id="element-89">
              :
            </div>
            <div className={`text-6xl md:text-7xl font-black ${isUrgent ? 'text-red-500' : 'text-white'}`} data-id="element-90">
              {formatTime(seconds)}
            </div>
          </div>
          <p className="text-red-400 font-bold text-lg" data-id="element-91">
            Después vuelve a $49.900 ARS.
          </p>
        </div>

        <div className="max-w-md mx-auto mb-12" data-id="element-92">
          <div className="text-gray-500 line-through font-bold text-2xl mb-2" data-id="element-93">
            $49.900 ARS
          </div>
          <div className="text-6xl font-black text-white mb-8" data-id="element-94">$19.990 ARS</div>
          <CTAButton text="🔥 → QUIERO EL PACK AHORA" isLink={true} className="py-5 text-xl" data-id="element-95" />

          <div className="mt-8" data-id="element-96">
            <img src="https://cdn.magicpatterns.com/uploads/iNdd7dNPFTmkMXnAUq87Qt/jo3l6snt.png" alt="Garantía 7 Días de Reembolso" className="w-48 mx-auto" data-id="element-97" />
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-400 font-medium" data-id="element-98">
          <span className="flex items-center gap-2" data-id="element-99">
            <LockIcon className="w-5 h-5" data-id="element-100" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-101">
            <ZapIcon className="w-5 h-5 text-brand-amber" data-id="element-102" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-103">
            <ShieldCheckIcon className="w-5 h-5 text-brand-green" data-id="element-104" /> Garantía 7
            días
          </span>
          <span className="flex items-center gap-2 w-full justify-center mt-2 md:mt-0 md:w-auto" data-id="element-105">
            <CreditCardIcon className="w-5 h-5" data-id="element-106" /> Mercado Pago | Tarjeta |
            Transferencia
          </span>
        </div>
      </div>
    </section>;
}